import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http'

import { Observable } from 'rxjs'
import { CookieService } from 'ngx-cookie-service'

/** Pass untouched request through to the next request handler. */
@Injectable({
  providedIn: 'root',
})
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(private _cookieService: CookieService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let accessToken = this._cookieService.get('accessToken')

    if (accessToken?.length === 0) {
      accessToken = sessionStorage.getItem('accessToken') || ''
    }

    if (accessToken && accessToken.length > 0) {
      req = req.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` },
      })
    } else {
      localStorage.removeItem('userId')
      localStorage.removeItem('roleId')
      localStorage.removeItem('username')
    }

    return next.handle(req)
  }
}
